import React from "react";

export default React.lazy(() => import("./MySwiper"));

const CardSlider = React.lazy(() => import("./CardSwiper"));
export {CardSlider};

const ModuleSwiper = React.lazy(() => import("./ModuleSwiper"));
export {ModuleSwiper};

const SliderComponent = React.lazy(() => import("./SliderComponent"));
export {SliderComponent};